// extracted by mini-css-extract-plugin
export var root = "_zv-0";
export var scroll = "_zv-1";
export var thumb = "_zv-3";
export var track = "_zv-2";